export default __webpack_public_path__ + "static/media/EventFrame.bd82e484.png";